/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChatMessageData,
  EnterRoomParam,
  GetSessionsResponse,
  GetSessionsUnreadMessageCountResponse,
  SendChatMessage,
} from '../models/index';

export interface ChatControllerEnterRoomRequest {
    EnterRoomParam: EnterRoomParam;
}

export interface ChatControllerGetMessagesRequest {
    sessionType?: number;
    toUserId?: string;
    cursor?: number;
    limit?: number;
    latestMessageId?: number;
}

export interface ChatControllerGetSessionsRequest {
    sessionType?: number;
    toUserId?: string;
    cursor?: number;
    limit?: number;
}

export interface ChatControllerSendMessageRequest {
    SendChatMessage: SendChatMessage;
    x_pop_platform?: ChatControllerSendMessageXPopPlatformEnum;
}

/**
 * 
 */
export class ChatApi extends runtime.BaseAPI {

    /**
     * Enter room
     */
    async chatControllerEnterRoomRaw(requestParameters: ChatControllerEnterRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['EnterRoomParam'] == null) {
            throw new runtime.RequiredError(
                'EnterRoomParam',
                'Required parameter "EnterRoomParam" was null or undefined when calling chatControllerEnterRoom().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/enterRoom`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['EnterRoomParam'],
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Enter room
     */
    async chatControllerEnterRoom(requestParameters: ChatControllerEnterRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.chatControllerEnterRoomRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get chat message list
     */
    async chatControllerGetMessagesRaw(requestParameters: ChatControllerGetMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ChatMessageData>>> {
        const queryParameters: any = {};

        if (requestParameters['sessionType'] != null) {
            queryParameters['sessionType'] = requestParameters['sessionType'];
        }

        if (requestParameters['toUserId'] != null) {
            queryParameters['toUserId'] = requestParameters['toUserId'];
        }

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['latestMessageId'] != null) {
            queryParameters['latestMessageId'] = requestParameters['latestMessageId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/messages`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * get chat message list
     */
    async chatControllerGetMessages(requestParameters: ChatControllerGetMessagesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChatMessageData>> {
        const response = await this.chatControllerGetMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get my session list 
     */
    async chatControllerGetSessionsRaw(requestParameters: ChatControllerGetSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSessionsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionType'] != null) {
            queryParameters['sessionType'] = requestParameters['sessionType'];
        }

        if (requestParameters['toUserId'] != null) {
            queryParameters['toUserId'] = requestParameters['toUserId'];
        }

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/sessions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * get my session list 
     */
    async chatControllerGetSessions(requestParameters: ChatControllerGetSessionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSessionsResponse> {
        const response = await this.chatControllerGetSessionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async chatControllerGetSessionsUnreadMessagesCountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSessionsUnreadMessageCountResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/sessions/unread-messages-count`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async chatControllerGetSessionsUnreadMessagesCount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSessionsUnreadMessageCountResponse> {
        const response = await this.chatControllerGetSessionsUnreadMessagesCountRaw(initOverrides);
        return await response.value();
    }

    /**
     * Leave room
     */
    async chatControllerLeaveRoomRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/leaveRoom`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Leave room
     */
    async chatControllerLeaveRoom(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.chatControllerLeaveRoomRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async chatControllerSendMessageRaw(requestParameters: ChatControllerSendMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['SendChatMessage'] == null) {
            throw new runtime.RequiredError(
                'SendChatMessage',
                'Required parameter "SendChatMessage" was null or undefined when calling chatControllerSendMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['x_pop_platform'] != null) {
            headerParameters['x-pop-platform'] = String(requestParameters['x_pop_platform']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/message`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SendChatMessage'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async chatControllerSendMessage(requestParameters: ChatControllerSendMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.chatControllerSendMessageRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const ChatControllerSendMessageXPopPlatformEnum = {
    Psl: 'psl',
    Popstore: 'popstore'
} as const;
export type ChatControllerSendMessageXPopPlatformEnum = typeof ChatControllerSendMessageXPopPlatformEnum[keyof typeof ChatControllerSendMessageXPopPlatformEnum];
